// src/data/terrain.ts — Terrenos Fase 4
export type TerrainDef = {
  id: string;
  name: string;
  description: string;
  duration: number;
  effects: { element?: string; damageMult?: number; healElement?: string };
};

export const TERRAINS: Record<string, TerrainDef> = {
  normal: { id:'normal', name:'Terreno Normal', description:'Sin efectos.', duration:99, effects:{} },
  vegetal: { id:'vegetal', name:'Campo Vegetal', description:'Cura 6% a terra cada turno, potencia terra +10%.', duration:4, effects:{ element:'terra', damageMult:1.10, healElement:'terra' } },
  rocoso: { id:'rocoso', name:'Campo Rocoso', description:'Potencia terra/roca +10%, defensa +10% a terra.', duration:4, effects:{ element:'terra', damageMult:1.10 } },
  humedo: { id:'humedo', name:'Terreno Húmedo', description:'Potencia aqua +10%, cura aqua.', duration:4, effects:{ element:'aqua', damageMult:1.10 } },
  volcanico: { id:'volcanico', name:'Campo Volcánico', description:'Potencia ignis +12%.', duration:4, effects:{ element:'ignis', damageMult:1.12 } },
};

export function getTerrain(id:string): TerrainDef | undefined { return TERRAINS[id]; }
